import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-phone-input',
    templateUrl: './phone-input.component.html',
    styleUrls: ['./phone-input.component.scss'],
    standalone: false
})
export class PhoneInputComponent {
  @Input() dataTestId: string;
  @Input() errorMessage: string;
  @Input() formControlRef: FormControl;
  @Input() isFullWidth = false;
  @Input() label: string;
  @Input() maskOverride?: string;
}
